import { createFeature, createReducer, on } from '@ngrx/store';

import { AiProvidersActions } from './ai-providers.actions';
import { AiProviderDto } from './models/ai-provider.model';

export interface AiProvidersState {
  error: string | null;
  loading: boolean;
  aiProviders: AiProviderDto[];
}

export const initialState: AiProvidersState = {
  error: null,
  loading: false,
  aiProviders: [],
};

const reducer = createReducer(
  initialState,
  on(AiProvidersActions.getAIProviders, (state) => ({ ...state, loading: true })),
  on(AiProvidersActions.loadSuccess, (state, { aiProviders }) => ({
    ...state,
    aiProviders: aiProviders?.map((am) => ({ ...am })) ?? [],
    loading: false,
  })),
  on(AiProvidersActions.loadFailure, (state, { error }) => ({
    ...state,
    error: String(error),
    loading: false,
  })),
);

export const aiProvidersFeature = createFeature({
  name: 'aiProviders',
  reducer,
});
